import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const userTypeService = {
    getAll,
    getAllUserTypes,
    addUserType,
    updateUserType,
    deleteUserType,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/user/types/getAllUserTypes/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllUserTypes() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/user/types/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addUserType(newUserType) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newUserType),
    };

    const response = await fetch(
        `${config.oat_api_url}/user/types/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateUserType(userTypeItem, userTypeId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(userTypeItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/user/types/update/${userTypeId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteUserType(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/user/types/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
